import React from 'react';
import StoreLogo from '@prisjakt/ui-store-logo';
import shallowEqual from 'shallowequal';

import RatingSmiley from '@prisjakt/ui-rating/src/smiley-rating';

import { Store } from 'src/types';
import { Rating } from '@prisjakt/ui-rating/src/types';
import { SHOP_LOGO_WIDTH } from '../../../../../../../../store/constants';

import * as S from './styles';

type OwnProps = {
  store: Store;
  rating?: Rating;
  hide?: boolean;
};

const StoreInfoColumn = React.memo(
  ({ store, rating, hide }: OwnProps) => {
    const highResolutionLogo = store.logo
      ? { url: store.logo, width: SHOP_LOGO_WIDTH }
      : null;
    return (
      <S.StoreInfo>
        <S.StoreInfoTitle>{store.name}</S.StoreInfoTitle>
        <StoreLogo
          name={store.name}
          storeId={store.id}
          featured={Boolean(store.featured)}
          hasImage={Boolean(store.hasLogo)}
          variant={S.VARIANTS.PRICE_LIST}
          logoUrl={highResolutionLogo?.url}
          width={highResolutionLogo?.width}
          showHighResolutionLogo={Boolean(highResolutionLogo)}
        />
        {!hide && rating && rating.whole > 0 && (
          <S.RatingWrapper>
            <S.RatingContainer data-rating={rating.roundedString}>
              <RatingSmiley
                featured={Boolean(store.featured)}
                rating={rating}
                reviewCount={store.userReviewSummary.countTotal}
                scoreVisibility="row"
                size="small"
              />
            </S.RatingContainer>
          </S.RatingWrapper>
        )}
      </S.StoreInfo>
    );
  },
  (prevProps, nextProps) => {
    const { store: prevStore, ...prevRest } = prevProps;
    const { store: nextStore, ...nextRest } = nextProps;
    const {
      name: prevName,
      hasLogo: prevHasLogo,
      featured: prevFeatured,
      userReviewSummary: prevUserReviewSummary,
    } = prevStore;
    const {
      name: nextName,
      hasLogo: nextHasLogo,
      featured: nextFeatured,
      userReviewSummary: nextUserReviewSummary,
    } = nextStore;
    return (
      shallowEqual(prevRest, nextRest) &&
      prevUserReviewSummary === nextUserReviewSummary &&
      prevName === nextName &&
      prevHasLogo === nextHasLogo &&
      prevFeatured === nextFeatured
    );
  }
);

export default StoreInfoColumn;
